<div class="agreement-modal">
    <h2 mat-dialog-title class="modal-title">Termos e condições para continuar</h2>

    <mat-dialog-content class="modal-content">
        <div class="modal-content">
            <ng-container *ngFor="let agreement of listAgreement">
                <div class="agreement-pdf">
                    <embed [src]="agreement.safePdfUrl" type="application/pdf" class="pdf-viewer" />
                </div>
            </ng-container>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="action-buttons">
        <ng-container *ngFor="let agreement of listAgreement">
            <mat-checkbox [(ngModel)]="agreement.agreementAccept" [required]="agreement.isMandatory"
                class="agreement-checkbox">
                Eu li e aceito o termo: <strong>{{ agreement.agreementName }}</strong>
            </mat-checkbox>
        </ng-container>
    </mat-dialog-actions>
    <mat-dialog-actions class="action-buttons">
        <button class="back-btn" (click)="close()">Voltar</button>
        <button class="continue-btn" (click)="confirm()" [disabled]="!allMandatoryAccepted()">
            Continuar
        </button>
    </mat-dialog-actions>
</div>